import { ReportType } from 'core/report/ReportData';
import { VideoReportDataProvider } from './VideoReportDataProvider';
import { ReportDataProvider } from './ReportDataProvider';
import { RebateReportDataProvider } from './RebateReportDataProvider';
import { GeneralReportDataProvider } from './GeneralReportDataProvider';
import { OutdoorReportDataProvider } from './OutdoorReportDataProvider';
import { BeaconMessageReportDataProvider } from './BeaconMessageReportDataProvider';
import { Actor } from 'core';

export function getDataProvider(
  actor: Actor | null,
  reportType: ReportType,
  onDimensionNameClick: (
    dimension: string,
    rowNameValue: string | number
  ) => void,
  onDateClick: (date: string) => void
): ReportDataProvider {
  if (reportType === ReportType.REBATE) {
    return new RebateReportDataProvider(onDimensionNameClick, onDateClick);
  }
  if (reportType === ReportType.OUTDOOR) {
    return new OutdoorReportDataProvider(onDimensionNameClick, onDateClick);
  }
  if (reportType === ReportType.LINE_MESSAGE) {
    return new BeaconMessageReportDataProvider(
      actor,
      onDimensionNameClick,
      onDateClick
    );
  }
  return reportType === ReportType.PERFORMANCE
    ? new GeneralReportDataProvider(onDimensionNameClick, onDateClick)
    : new VideoReportDataProvider(onDimensionNameClick, onDateClick);
}
